import { getWorkOrderCounts, getWorkOrders, getWorkOrder, noChargeWorkOrder, voidWorkOrder, setWorkOrderPONumber, setWorkOrderDiscount, setWorkOrderBillingOnly, setWorkOrderInvoiceNumber, undoVoidWorkOrder, undoNoChargeWorkOrder, removeCustomerSignature, uploadCustomerSignedDoc, emailWorkOrderPdf, sendWorkOrderSignatureRequest } from "../api/workOrders";

const grabWorkOrderCounts = async (): Promise<any> => {
    try {
        const apiResults = await getWorkOrderCounts();

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in getWorkOrderCounts", err);
        throw err;
    }
};

const grabWorkOrders = async (status?: number, trade?: string): Promise<any> => {
    try {
        const apiResults = await getWorkOrders(status, trade);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in getWorkOrders", err);
        throw err;
    }
};

const grabWorkOrder = async (workOrderID: number): Promise<any> => {
    try {
        const apiResults = await getWorkOrder(workOrderID);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in getWorkOrder", err);
        throw err;
    }
};

const markWorkOrderNoCharge = async (workOrderID: number, reason: string): Promise<any> => {
    try {
        const apiResults = await noChargeWorkOrder(workOrderID, reason);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in markWorkOrderNoCharge", err);
        throw err;
    }
};

const voidWorkOrderRequest = async (workOrderID: number, reason: string): Promise<any> => {
    try {
        const apiResults = await voidWorkOrder(workOrderID, reason);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in voidWorkOrderRequest", err);
        throw err;
    }
};

const setPONumberRequest = async (workOrderID: number, poNumber: string): Promise<any> => {
    try {
        const apiResults = await setWorkOrderPONumber(workOrderID, poNumber);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in setPONumberRequest", err);
        throw err;
    }
};

const setDiscountRequest = async (workOrderID: number, discountAmount: number): Promise<any> => {
    try {
        const apiResults = await setWorkOrderDiscount(workOrderID, discountAmount);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in setDiscountRequest", err);
        throw err;
    }
};

const setInvoiceNumberRequest = async (workOrderID: number, invoiceNumber: string): Promise<any> => {
    try {
        const apiResults = await setWorkOrderInvoiceNumber(workOrderID, invoiceNumber);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in setInvoiceNumberRequest", err);
        throw err;
    }
};

const undoVoidWorkOrderRequest = async (workOrderID: number): Promise<any> => {
    try {
        const apiResults = await undoVoidWorkOrder(workOrderID);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in undoVoidWorkOrderRequest", err);
        throw err;
    }
};

const undoNoChargeWorkOrderRequest = async (workOrderID: number): Promise<any> => {
    try {
        const apiResults = await undoNoChargeWorkOrder(workOrderID);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in undoNoChargeWorkOrderRequest", err);
        throw err;
    }
};

const removeCustomerSignatureRequest = async (workOrderID: number, reason: string): Promise<any> => {
    try {
        const apiResults = await removeCustomerSignature(workOrderID, reason);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in removeCustomerSignatureRequest", err);
        throw err;
    }
};

const uploadCustomerSignedDocRequest = async (workOrderID: number, file: File, notes?: string): Promise<any> => {
    try {
        const apiResults = await uploadCustomerSignedDoc(workOrderID, file, notes);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in uploadCustomerSignedDocRequest", err);
        throw err;
    }
};

const emailWorkOrderPdfRequest = async (
    workOrderID: number,
    payload: { recipient: string; recipients?: string[]; cc?: string[]; subject?: string; body?: string }
): Promise<any> => {
    try {
        const apiResults = await emailWorkOrderPdf(workOrderID, payload);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in emailWorkOrderPdfRequest", err);
        throw err;
    }
};

const sendWorkOrderSignatureRequestCall = async (
    workOrderID: number,
    payload: { recipient: string }
): Promise<any> => {
    try {
        const apiResults = await sendWorkOrderSignatureRequest(workOrderID, payload);

        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in sendWorkOrderSignatureRequestCall", err);
        throw err;
    }
};

const setBillingOnlyRequest = async (workOrderID: number, billingOnly: boolean): Promise<any> => {
    try {
        const apiResults = await setWorkOrderBillingOnly(workOrderID, billingOnly);
        if (!apiResults) {
            throw new Error("Fetch Failed.");
        }
        return apiResults;
    } catch (err) {
        console.error("Error in setBillingOnlyRequest", err);
        throw err;
    }
};

export { grabWorkOrderCounts, grabWorkOrders, grabWorkOrder, markWorkOrderNoCharge, voidWorkOrderRequest, setPONumberRequest, setDiscountRequest, setBillingOnlyRequest, setInvoiceNumberRequest, undoVoidWorkOrderRequest, undoNoChargeWorkOrderRequest, removeCustomerSignatureRequest, uploadCustomerSignedDocRequest, emailWorkOrderPdfRequest, sendWorkOrderSignatureRequestCall };
